import { styled } from '@mui/material'
import { AvatarWrapper } from '../../../../../components/wrapper'

export const AvatarNextDate = styled(AvatarWrapper)(() => ({
  width: '50px',
  height: '50px'
}))
